import { InputAdornment, TextField } from '@mui/material';
import React from 'react';

interface IconTextFieldProps {
    id?: string;
    placeholder?: string;
    size?: 'small' | 'medium';
    label?: string;
    variant?: 'standard' | 'outlined' | 'filled';
    prefix?: React.ReactNode;
    suffix?: React.ReactNode;
    slotProps?: Record<string, unknown>;
    value?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    margin?: 'none' | 'dense' | 'normal';
    required?: boolean;
    fullWidth?: boolean;
    name?: string;
    type?: string;
    autoComplete?: string;
    disabled?: boolean;
    autoFocus?: boolean;
}

const IconTextField: React.FC<IconTextFieldProps> = ({
    id,
    value,
    placeholder,
    size = 'small',
    label,
    variant = 'outlined',
    prefix,
    suffix,
    slotProps,
    onChange,
    margin,
    required,
    fullWidth,
    name,
    type,
    autoComplete,
    disabled = false,
    autoFocus = false,
}) => {
    return (
        <TextField
            disabled={disabled}
            autoFocus={autoFocus}
            autoComplete={autoComplete}
            name={name}
            type={type}
            required={required}
            fullWidth={fullWidth}
            onChange={onChange}
            margin={margin}
            value={value}
            size={size}
            placeholder={placeholder}
            id={id}
            label={label}
            className="pl-10 p-2 border border-gray-300 rounded w-full"
            slotProps={{
                ...slotProps,
                input: {
                    startAdornment: prefix && (
                        <InputAdornment position="start">
                            {prefix}
                        </InputAdornment>
                    ),
                    endAdornment: suffix && (
                        <InputAdornment position="end">{suffix}</InputAdornment>
                    ),
                },
            }}
            variant={variant}
        />
    );
};

export default IconTextField;
